<template>
  <div>
    <el-select
      v-model="value"
      placeholder="Select"
      @change="getNavitionTransactionReport"
    >
      <el-option v-for="item in years" :key="item" :label="item" :value="item">
      </el-option>
    </el-select>
    <el-select
      v-model="companyFilter"
      class="box-item"
      @change="handleCompanyChange"
    >
      <el-option
        v-for="company in companyList"
        :key="company.value"
        :label="company.label"
        :value="company.value"
      ></el-option>
    </el-select>
    <rabbey-table-3
      :loading="mainTableLoading"
      :data="transactionUsers"
      :columns="transactionColumns"
    />

    <el-drawer
      title="Detalle de Transacciones de Navition"
      :visible="openDetail"
      :before-close="CloseTransactionDetail"
      size="60%"
    >
      <el-row style="margin-top: 20px">
        <el-form label-position="top">
          <el-col :span="11" style="margin-left: 20px">
            <el-form-item label="Agente de Cobro">
              <el-input
                v-model="transactionDeatail.PersonName"
                disabled
                style="width: 300px"
              />
            </el-form-item>
          </el-col>

          <el-col :span="11">
            <el-form-item label="Mes">
              <el-input
                v-model="transactionDeatail.Month"
                disabled
                style="width: 300px"
              />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>

      <div>
        <DetailChart ref="detailChart" :DetailParams="DetailData" />
      </div>

      <h2 style="margin-left: 20px">Listado de Transacciones</h2>

      <rabbey-table-3
        :loading="detailTableLoading"
        :data="transactionDeatail.TransactionList"
        :columns="transactionDetailColumns"
        style="margin: 20px"
      />
    </el-drawer>
  </div>
</template>

<script src="https://cdn.jsdelivr.net/npm/chart.js"></script>
<script>
// import ImagePerson from "@/components/functionals/ImagePerson.vue";
import CashFlowHyperlink from "@/components/functionals/CashFlowHyperlink.vue";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import { formatDate } from "@/utils";
import DetailChart from "@/views/Charts/NavitionTransactionChart.vue";

export default {
  components: { RabbeyTable3 },
  name: "NavitionTransactions",
  components: {
    DetailChart
  },
  data() {
    return {
      companyFilter: "TB",
      companyList: [
        {
          label: "Tennos Business",
          value: "TB"
        },
        {
          label: "Rabbey",
          value: "RB"
        },
        {
          label: "Magytrack",
          value: "MTR"
        }
      ],
      mainTableLoading: false,
      detailTableLoading: false,
      openDetail: false,
      years: [],
      value: this.year,
      transactionUsers: [],
      transactionDeatail: {
        PersonName: "",
        Month: "",
        TransactionList: []
      },
      transactionColumns: [
        {
          prop: "UserName",
          label: "Usuario de Navition",
          width: 300,
          sortable: true
          // formatter: ImagePerson,
          // attrs: {
          //   imgKey: "SalesPersonPhoto"
          // }
        },
        {
          prop: "Enero",
          label: "Enero",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Febrero",
          label: "Febrero",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Marzo",
          label: "Marzo",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Abril",
          label: "Abril",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Mayo",
          label: "Mayo",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Junio",
          label: "Junio",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Julio",
          label: "Julio",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Agosto",
          label: "Agosto",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Septiembre",
          label: "Septiembre",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Octubre",
          label: "Octubre",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Noviembre",
          label: "Noviembre",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Diciembre",
          label: "Diciembre",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        }
        // {
        //   prop: "Total",
        //   label: "Total"
        // }
      ],
      transactionDetailColumns: [
        {
          prop: "EntryNo",
          label: "No. Transacción",
          width: 150
        },
        {
          prop: "UserName",
          label: "Usuario Navition",
          width: 250
        },
        {
          prop: "PostingDate",
          label: "Fecha Transacción",
          formatter: (row) => formatDate(row.PostingDate, "DD/MM/yyyy"),
          width: 150
        },
        {
          prop: "Description",
          label: "Descripción"
        }
      ],
      DetailChartX: ["1", "2", "3", "4", "5", "6", "7", "8"],
      DetailChartY: [5, 20, 36, 10, 10, 20, 40, 15],
      DetailData: {
        Year: 0,
        Month: 0,
        CompanyId: "",
        UserName: ""
      }
    };
  },
  beforeCreate() {
    var fecha = new Date();
    this.year = fecha.getFullYear();
  },
  created() {
    this.getNavitionTransactionReport();
    this.yearCalculator();
  },
  methods: {
    getNavitionTransactionReport() {
      this.mainTableLoading = true;
      this.$http
        .get("/api/accountsReceivable/NavitionTransactionReport", {
          params: {
            Year: this.value,
            CompanyId: this.companyFilter
          }
        })
        .then((resp) => {
          this.transactionUsers = resp.data;
          this.mainTableLoading = false;
        });
    },
    handleCompanyChange(company) {
      if (company) {
        this.companyFilter = company;
        this.getNavitionTransactionReport();
      } else {
        this.companyFilter = "TB";
        this.getNavitionTransactionReport();
      }
    },
    yearCalculator() {
      for (var i = 2018; i <= this.year; i++) {
        this.years.push(i);
      }
    },

    OpenTransactionDetail(row, column) {
      this.detailTableLoading = true;
      this.transactionDeatail.PersonName = row.UserName;
      this.transactionDeatail.Month = column;
      this.DetailData = {
        Year: this.value,
        Month: this.getMonthNumber(column),
        CompanyId: this.companyFilter,
        UserName: row.UserName
      };
      this.$http
        .get("/api/accountsReceivable/NavitionTransactionReportDetail", {
          params: {
            Year: this.DetailData.Year,
            Month: this.DetailData.Month,
            CompanyId: this.companyFilter,
            UserName: this.DetailData.UserName
          }
        })
        .then((resp) => {
          this.transactionDeatail.TransactionList = resp.data;
          this.detailTableLoading = false;
          this.$refs.detailChart.getChartData();
        });
      this.openDetail = true;
    },
    CloseTransactionDetail() {
      this.openDetail = false;
      this.transactionDeatail.TransactionList = [];
      this.$refs.detailChart.bar.series[0].data = [];
      this.$refs.detailChart.loading = true;
    },
    getMonthNumber(month) {
      switch (month) {
        case "Enero":
          return 1;
        case "Febrero":
          return 2;
        case "Marzo":
          return 3;
        case "Abril":
          return 4;
        case "Mayo":
          return 5;
        case "Junio":
          return 6;
        case "Julio":
          return 7;
        case "Agosto":
          return 8;
        case "Septiembre":
          return 9;
        case "Octubre":
          return 10;
        case "Noviembre":
          return 11;
        case "Diciembre":
          return 12;
      }
    }
  }
};
</script>
